import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import PortfolioGallery from "./PortfolioGallery";
import PricingSection from "./PricingSection";
import StatsSection from "../HomePage/StatsSection";

const FullPortfolioPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Our Portfolio | Ashlar Building Group</title>
        <meta
          name="description"
          content="Explore Ashlar Building Group's portfolio of completed projects — custom homes, ADUs, full remodels, and HOA reconstruction across California."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://yourdomain.com/portfolio" />
        <meta property="og:title" content="Our Portfolio | Ashlar Building Group" />
        <meta
          property="og:description"
          content="From luxury custom homes to garage conversion ADUs — browse Ashlar's completed projects built with integrity, precision, and third-generation craftsmanship."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yourdomain.com/portfolio" />
      </Helmet>

      <HeroSection />
      <PortfolioGallery />
      <StatsSection/>
      <PricingSection/>
    </>
  );
};

export default FullPortfolioPage;